var crypto = require('crypto');

const salt ='pbiclient@';

function encodeLowerMd5(string) {
    var md5 = crypto.createHash('md5');
    return md5.update(string).digest('hex').toLowerCase();
}

function encodeUpperMd5(string) {
    var md5 = crypto.createHash('md5');
    return md5.update(string).digest('hex').toUpperCase();
}

const toMD5withSalt =(string)=>{
	return encodeLowerMd5(string);
	
}

export { encodeLowerMd5, encodeUpperMd5,toMD5withSalt };